<template>
  <div class="roomManagement">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="考场名称">
          <el-input v-model="filter.title" placeholder="请输入考场名称"></el-input>
        </el-form-item>
        <el-form-item label="考试项目">
          <el-input v-model="filter.testProject" placeholder="请输入考试项目"></el-input>
        </el-form-item>
        <el-form-item label="班级名称">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="考试类型">
          <el-select v-model="filter.type" placeholder="请选择考试类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="理论考试" :value="1"></el-option>
            <el-option label="实操能力考核" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="add">创建考试</el-button>
      <el-table :data="list" border>
        <el-table-column align="center" label="考场名称" prop="title" width=""></el-table-column>
        <el-table-column align="center" label="关联班级" width="">
          <template v-slot="{ row }">
            <span v-if="row.skuList && row.skuList.length">
              <el-tag
                v-for="item in row.skuList"
                :key="item.skuId"
                size="small"
                style="margin: 2px;"
              >{{ item.skuName }}（{{ item.quota }}）</el-tag>
            </span>
            <span v-else-if="row.skuName">{{ row.skuName }}</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="考试类型">
          <template v-slot="{ row }">
            <span v-if="row.type === 1">理论考试</span>
            <span v-else-if="row.type === 2">实操能力考核</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="考试项目" prop="testProject" width=""></el-table-column>
        <el-table-column align="center" label="已预约人数" width="140">
          <template slot-scope="scope">
            {{ scope.row.numAdd || 0 }}/{{ scope.row.numAddMax }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="" width="280">
          <template slot-scope="scope">
            <a href="javascript:;" @click="edit(scope.row)">编辑</a> &nbsp;
            <a href="javascript:;" @click="$refs.lookUser.init(scope.row.id, scope.row.type, scope.row.skuList)">查看学员</a> &nbsp;
            <a href="javascript:;" @click="editState(scope.row)">{{scope.row.state === 1 ? '禁用' : '启用'}}</a>
            <template v-if="scope.row.isEnd === 2">
              &nbsp;
              <a href="javascript:;" @click="updateAchievement(scope.row)">发布成绩</a>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" size="small" label-width="140px" class="demo-ruleForm">
        <!-- 基础信息 -->
        <div class="form-section">
          <div class="form-section-header">基础信息</div>
          <el-form-item label="考场名称" prop="title">
            <el-input v-model="ruleForm.title" maxlength="40" placeholder="请输入考场名称"></el-input>
          </el-form-item>
          <el-form-item label="专业岗位名称" prop="majorName">
            <el-input v-model="ruleForm.majorName" maxlength="40" placeholder="请输入专业岗位名称"></el-input>
          </el-form-item>
          <el-form-item label="考试项目" prop="testProject">
            <el-input v-model="ruleForm.testProject" maxlength="20" placeholder="请输入考试项目"></el-input>
          </el-form-item>
          <el-form-item label="考试类型" prop="type">
            <el-select style="width: 100%" v-model="ruleForm.type" placeholder="请选择考试类型">
              <el-option label="理论考试" :value="1" />
              <el-option label="实操能力考核" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="考场总可预约人数" prop="numAddMax">
            <el-input v-model="ruleForm.numAddMax" maxlength="9" placeholder="请输入考场总可预约人数, 仅可输入阿拉伯数字"></el-input>
          </el-form-item>
          <el-form-item label="考试须知" prop="instructions">
            <Editor v-if="dialogVisible" v-model="ruleForm.instructions" />
          </el-form-item>
        </div>

        <!-- 关联班级配置 -->
        <div class="form-section">
          <div class="form-section-header">关联班级配置</div>
          <el-form-item label="关联班级" prop="skuList">
            <div class="sku-list-box">
              <el-button type="primary" size="small" :disabled="!!row" @click="$refs.checkSku.init(ruleForm.skuList)">选择班级</el-button>
              <span class="sku-list-tip" v-if="ruleForm.skuList.length">已选 {{ ruleForm.skuList.length }} 个班级</span>
              <el-table v-if="ruleForm.skuList.length" :data="ruleForm.skuList" border style="margin-top: 10px;" size="small">
                <el-table-column align="center" label="班级名称" prop="skuName"></el-table-column>
                <el-table-column align="center" label="配额" width="160">
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.quota"
                      :min="0"
                      :max="99999"
                      size="small"
                      controls-position="right"
                      style="width: 130px;"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <div class="sku-list-summary" v-if="ruleForm.skuList.length">
                配额合计：<span :class="{ 'quota-mismatch': !isQuotaMatch }">{{ skuQuotaSum }}</span> / 考场总可预约人数：{{ ruleForm.numAddMax || 0 }}
                <span v-if="!isQuotaMatch && ruleForm.numAddMax" class="quota-warn">（需等于）</span>
              </div>
              <p class="sku-list-warn">提示：各班级可预约名额之和不可大于考场总可预约人数</p>
            </div>
          </el-form-item>
        </div>

        <!-- 预约与考试时间 -->
        <div class="form-section">
          <div class="form-section-header">预约与考试时间</div>
          <div class="form-row">
            <el-form-item label="开考前" prop="numDayNoReservation">
              <el-input v-model="ruleForm.numDayNoReservation" maxlength="5" style="width: 200px" placeholder="请输入天数, 最小为1天"></el-input>
              天不可预约考试
            </el-form-item>
            <el-form-item label="考试时间类型" prop="isImediateTest">
              <el-radio-group v-model="ruleForm.isImediateTest">
                <el-radio :label="false">固定时间</el-radio>
                <el-radio :label="true">浮动时间</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="考试开始时间" prop="testFrom">
              <el-date-picker
                v-model="ruleForm.testFrom"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始时间"
                popper-class="no-button-link"
                :picker-options="picker"
                @change="beginChange"
              />
            </el-form-item>
            <el-form-item label="考试结束时间" prop="testTo">
              <el-date-picker
                v-model="ruleForm.testTo"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间"
                popper-class="no-button-link"
                :picker-options="picker"
                @change="endChange"
              />
            </el-form-item>
            <el-form-item label="答题时间" prop="testMinutes">
              <el-input v-model="ruleForm.testMinutes" placeholder="请输入" style="width: 100px"></el-input>（分钟）
            </el-form-item>
          </div>
        </div>

        <!-- 其他配置 -->
        <div class="form-section">
          <div class="form-section-header">其他配置</div>
          <div class="form-row">
            <el-form-item label="状态" prop="state">
              <el-radio-group v-model="ruleForm.state">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否推送讯飞" prop="isNeedPush">
              <el-radio-group v-model="ruleForm.isNeedPush">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </span>
      <CheckSku ref="checkSku" @check="check" />
    </el-dialog>

    <LookUser ref="lookUser" />
  </div>
</template>

<script>
import { getListTestPlan, addTestPlan, updateTestPlan, updateStatus, updateAchievement } from '@/api/product/written'
import Editor from '@/components/QuillEditor/index2'
import CheckSku from './components/CheckSku.vue'
import LookUser from './components/LookUser.vue'
import dayjs from 'dayjs';

export default {
  name: 'RoomManagement',
  components: { Editor, CheckSku, LookUser },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        title: '',
        testProject: '',
        skuName: '',
        type: ''
      },
      list: [],
      total: 0,
      title: '',
      dialogVisible: false,
      innerVisible: false,
      picker: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000
        }
      },
      ruleForm: {
        title: '',
        testProject: '',
        type: '',
        numAddMax: '',
        instructions: '',
        majorName: '',
        numDayNoReservation: '',
        skuList: [],
        isImediateTest: '',
        testFrom: '',
        testTo: '',
        testMinutes: '',
        state: '',
        isNeedPush: 2
      },
      row: null
    }
  },
  computed: {
    skuQuotaSum() {
      return this.ruleForm.skuList.reduce((sum, item) => sum + (parseInt(item.quota, 10) || 0), 0)
    },
    isQuotaMatch() {
      const numAddMax = parseInt(this.ruleForm.numAddMax, 10)
      if (!numAddMax && numAddMax !== 0) return true
      return this.skuQuotaSum === numAddMax
    },
    formRules() {
      return {
        title: [{ required: true, message: '请输入考场名称', trigger: 'blur' }],
        testProject: [{ required: true, message: '请输入考试项目', trigger: 'blur' }],
        type: [{ required: true, message: '请输入考试类型', trigger: 'change' }],
        majorName: [{ required: true, message: '请输入专业岗位名称', trigger: 'blur' }],
        numAddMax: [
          { required: true, message: '请输入考场可预约人数', trigger: 'blur' },
          { pattern: /^\d{1,}$/, message: "请输入正整数", trigger: "blur" },
        ],
        numDayNoReservation: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: "请输入正整数", trigger: "blur" }
        ],
        skuList: [
          { type: 'array', required: true, message: '请选择班级', trigger: 'change' },
          { validator: this.validateQuotaSum, trigger: 'change' }
        ],
        state: [{ required: true, message: '请选择', trigger: 'change' }],
        isImediateTest: [{ required: true, message: '请选择', trigger: 'change' }],
        testFrom: [{ required: true, message: '请选择', trigger: 'change' }],
        testTo: [{ required: true, message: '请选择', trigger: 'change' }],
        testMinutes: [{ required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^\d{1,}$/, message: "请输入正整数", trigger: "blur" }],
        isNeedPush: [{ required: true, message: '请选择是否推送讯飞', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 校验器：配额合计 === numAddMax
    validateQuotaSum(rule, value, callback) {
      if (!value || !value.length) {
        return callback()
      }
      const numAddMax = parseInt(this.ruleForm.numAddMax, 10)
      if (!numAddMax) {
        return callback()
      }
      const sum = value.reduce((s, item) => s + (parseInt(item.quota, 10) || 0), 0)
      if (sum !== numAddMax) {
        return callback(new Error('各班级可预约名额之和与考场总可预约人数不符'))
      }
      callback()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    // 列表
    async getList() {
      const res = await getListTestPlan(this.filter)
      if (res.code !== 0) return this.$message.error(res.message)
      this.list = res.data.records
      this.total = +res.data.total
    },
    // 提交 新增 / 编辑
    submit(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          // 额外校验：配额合计 === numAddMax
          const numAddMax = parseInt(this.ruleForm.numAddMax, 10)
          if (this.skuQuotaSum !== numAddMax) {
            return this.$message.error('各班级可预约名额之和与考场总可预约人数不符')
          }
          // 提交前清理 quota 为数字，并构造 sendObj
          const sendObj = {...this.ruleForm}
          sendObj.skuList = this.ruleForm.skuList.map(item => ({
            skuId: item.skuId,
            quota: parseInt(item.quota, 10) || 0
          }))
          let res
          if (this.row) {
            // 编辑
            sendObj.id = this.row.id
            res = await updateTestPlan(sendObj)
          } else {
            // 新增
            res = await addTestPlan(sendObj)
          }
          if (res.code !== 0) return this.$message.error(res.message)
          this.$message.success('操作成功!')
          this.handleClose()
          this.getList()
        } else {
          this.$message.warning('请完善内容后继续操作')
        }
      })
    },
    async editState(row) {
      const res = await updateStatus({ id: row.id, state: row.state === 1 ? 2 : 1 })
      this.$message.success('操作成功!')
      this.getList()
    },
    // 发布成绩
    updateAchievement(row) {
      this.$confirm('是否确认发布成绩?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await updateAchievement({ id: row.id })
        this.$message.success('操作成功!')
        this.getList()
      }).catch(() => {})
    },
    add() {
      this.title = '创建考试'
      this.dialogVisible = true
    },
    edit(row) {
      if (dayjs().isAfter(dayjs(row.testFrom).subtract(1, 'day'))) {
        this.$message.warning('考场开始时间前一天后不可编辑考场信息!')
        return
      }
      this.title = '编辑考试'
      Object.keys(this.ruleForm).forEach(key => {
        if (key === 'skuList') {
          // 兼容老数据：没有 skuList 时用 skuId/skuName 构造单条
          if (row.skuList && row.skuList.length) {
            this.ruleForm.skuList = row.skuList.map(item => ({
              skuId: item.skuId,
              skuName: item.skuName,
              quota: item.quota
            }))
          } else if (row.skuId) {
            this.ruleForm.skuList = [{
              skuId: row.skuId,
              skuName: row.skuName || '',
              quota: row.numAddMax || 0
            }]
          } else {
            this.ruleForm.skuList = []
          }
        } else {
          this.ruleForm[key] = row[key]
        }
      })
      this.ruleForm.testFrom = row.testFrom + ':00'
      this.ruleForm.testTo = row.testTo + ':00'
      this.row = row
      this.dialogVisible = true
    },
    check(selectedList) {
      // 多选回填：保留已存在的 quota，只追加新选的班级
      const existingMap = new Map(this.ruleForm.skuList.map(item => [item.skuId, item]))
      const merged = selectedList.map(item => {
        const skuId = item.id
        const existed = existingMap.get(skuId)
        if (existed) {
          return { skuId, skuName: item.skuName, quota: existed.quota }
        }
        return { skuId, skuName: item.skuName, quota: 0 }
      })
      this.ruleForm.skuList = merged
    },
    removeSkuRow(index) {
      this.ruleForm.skuList.splice(index, 1)
      // 触发校验刷新（清掉旧的"请选择班级"错误）
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate(['skuList'])
      })
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
      // this.$refs.ruleForm.resetFields()
      this.row = null
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = key === 'skuList' ? [] : (key === 'isNeedPush' ? 2 : '')
      })
    },
    beginChange(v) {
      if ((new Date(v).getTime() - new Date().getTime()) < 0) {
        this.ruleForm.testFrom = ''
        return this.$message.warning('不能选择当前时间之前的时间')
      }
      if (this.ruleForm.testTo && v) {
        const time =
          new Date(this.ruleForm.testTo).getTime() - new Date(v).getTime()
        if (time < 0) {
          this.ruleForm.testFrom = ''
          this.$message.warning('开始时间不能晚于结束时间')
        }
      }
    },
    endChange(v) {
      if ((new Date(v).getTime() - new Date().getTime()) < 0) {
        this.ruleForm.testTo = ''
        return this.$message.warning('不能选择当前时间之前的时间')
      }
      if (this.ruleForm.testFrom && v) {
        const time =
          new Date(v).getTime() - new Date(this.ruleForm.testFrom).getTime()
        if (time < 0) {
          this.ruleForm.testTo = ''
          this.$message.warning('开始时间不能晚于结束时间')
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.form-section {
  margin-bottom: 10px;
  .form-section-header {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 18px;
    margin-bottom: 8px;
    padding-left: 8px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 13px;
      background: #409EFF;
      margin-right: 6px;
      vertical-align: -2px;
    }
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
  }
}
// 压紧表单项间距
.demo-ruleForm >>> .el-form-item {
  margin-bottom: 14px;
}
.demo-ruleForm >>> .el-form-item:last-child {
  margin-bottom: 0;
}
.sku-list-box {
  .sku-list-tip {
    margin-left: 12px;
    color: #909399;
    font-size: 13px;
  }
  .sku-list-summary {
    margin-top: 10px;
    font-size: 13px;
    color: #606266;
    .quota-mismatch {
      color: #f56c6c;
      font-weight: bold;
    }
    .quota-warn {
      color: #f56c6c;
      margin-left: 4px;
    }
  }
  .sku-list-warn {
    margin: 8px 0 0;
    font-size: 12px;
    color: #909399;
  }
}
</style>
